import React, { useImperativeHandle, forwardRef, useEffect, useState } from 'react';
import { useErrorInputs } from "../../../hooks/useErrorInputs";
import { useDataAuth } from "../../../hooks/useDataAuth";
import { useTranslation } from "react-i18next";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Grid from '@mui/material/Grid';
import { fetchOrders, fetchProducts } from '../../../services/store.service';
import moment from 'moment';

export const StoreForm = forwardRef(({ dto, handleInputChange,  handleDirectInputChange, isView }, ref) =>{
    const fieldsRequired = ['document'];
    const [errorInputs, , , validForm] = useErrorInputs({});
    const [{ userSession }] = useDataAuth();
    const { t } = useTranslation();
    const [orderReferences, setOrderReferences] = useState([]);

    useImperativeHandle(ref, () => ({
        getData: () => dto, 
        errorInputs,
        validForm: () => validForm(fieldsRequired, dto)
    }));

    useEffect(() => {
        const fetchData = async () => {
            try {
                const responseStoreages = await fetchOrders(dto.id_company, userSession.token);
                if (responseStoreages.data && responseStoreages.data.length > 0) 
                    setOrderReferences(responseStoreages.data);
            } catch (e) {
                console.error("Error fetching service JSON:", e.message);
            } finally {
                console.log("fetchData completed");
            }
        };
        fetchData();
    }, [dto.id_company, userSession.token]);

    const searhProducts = async (e) => {
        const { value } = e.target;
        handleSetDataFields(value); 
        if(value !== '' && value) {
            const responseStoreages = await fetchProducts(userSession.token, value);
            if (responseStoreages.data && responseStoreages.data.length > 0) {;
                responseStoreages.data.forEach((product) => {
                    product.isCreated = false; 
                    product.state = '1';
                    product.observation = '';
                    product.locationWarehouse = ''
                    product.amount_expected = product.quantity
                });
                handleDirectInputChange('products', responseStoreages.data);
            }
        }
    }

    const handleSetDataFields = async (id)  => {
        orderReferences.forEach(order => {
            if (order.code === id) {
                handleDirectInputChange('responsible', String(order.receiver || ''));
                handleDirectInputChange('warehouse', String(order.warehouse || ''));
                handleDirectInputChange('code', id);
            }
        });
    }
    
    const handleChangeDate = (e, name) => handleDirectInputChange(name, moment(e).format('YYYY/MM/DD'));
  return (
    <>
        <Grid container spacing={1} sx={{ mt: 2 }}>
            <Grid size={{ xs: 12, sm: 6 }}>
                <FormControl fullWidth required disabled={isView} size="small" error={Boolean(errorInputs.document?.isError)}>
                    <InputLabel id="order-label">{t('commonFields.orderReference')}</InputLabel>
                    <Select labelId="order-label" label={t('commonFields.orderReference')} name="document"
                        value={dto.document}
                        onChange={handleInputChange}
                        onBlur={searhProducts}
                    >
                        {orderReferences.map(o => <MenuItem key={o.code} value={o.code}>{o.code}</MenuItem>)}
                    </Select>
                    {errorInputs.document?.isError && <FormHelperText>{errorInputs.document.messageError}</FormHelperText>}
                </FormControl>
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker 
                        disabled={isView}
                        label={t('commonFields.entryDate')}
                        format="DD/MM/YYYY" 
                        maxDate={moment()}
                        value={dto.dateOfEntry ? moment(dto.dateOfEntry) : null }
                        onChange={(e) => handleChangeDate(e, 'dateOfEntry')}
                        slotProps={{
                                textField: {
                                id: 'dateOfEntry',
                                name: 'dateOfEntry',
                                size: "small",
                                fullWidth: true,
                                required: false,
                                error: Boolean(errorInputs['dateOfEntry']?.isError),
                                helperText: errorInputs['dateOfEntry']?.messageError,
                                InputLabelProps: { shrink: true }
                            }
                        }}
                    />
                </LocalizationProvider>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
                <TextField fullWidth required disabled name="responsible" label={t('commonFields.approver')} size="small" value={dto.responsible} />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
                <TextField fullWidth disabled={isView} name="observation" label={t('crm.products.observation')} size="small" value={dto.observation}
                    onChange={handleInputChange}
                />
            </Grid> 
            <Grid size={{ xs: 12, sm: 6 }}>
                <TextField fullWidth required disabled name="warehouse" label={t('commonFields.warehouse')}  size="small" value={dto.warehouse}/>
            </Grid>
        </Grid>

        
    </>
  )
});
